export const productDetails = {
  checkIn: {
    name: 'Check-ins',
    description: 'Conduct asynchronous meetings in Slack',
  },
  project: {
    name: 'Projects (Jira)',
    description: 'Manage Jira Software issues in Slack',
  },
  helpDesk: {
    name: 'HelpDesk (Jira)',
    description: 'Manage Jira service requests in Slack',
  },
  wiki: {
    name: 'Wiki (Confluence)',
    description: 'Answer with Confluence articles in Slack',
  },
  report: {
    name: 'Reports (Jira)',
    description: 'Share actionable Jira reports in Slack',
  },
};
